var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PlantillaHome',[_c('div',{attrs:{"slot":"contenido"},slot:"contenido"},[_c('report-indicators')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }